import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { HostConfigurationEntity } from "../../types/HostConfigurationEntity";
import { HostConfigurationDtoToEntity } from "../mappers/HostConfigurationDtoToEntity";
import { HostConfigurationEntityToDto } from "../mappers/HostConfigurationEntityToDto";

const HostConfigurationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        HostConfigurationLoad: builder.query<HostConfigurationEntity, FormQuery>({
            providesTags: [ResourceName.HOST_CONFIGURATIONS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_CONFIGURATIONS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return HostConfigurationDtoToEntity(response);
            },
        }),
        HostConfigurationSave: builder.mutation<HostConfigurationEntity, FormMutation<HostConfigurationEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_CONFIGURATIONS}`;
                const method = "POST";

                const body = HostConfigurationEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.HOST_CONFIGURATIONS],
        }),
        HostConfigurationUpdate: builder.mutation<HostConfigurationEntity, FormMutation<HostConfigurationEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_CONFIGURATIONS}/${mutation.data.id}`;
                const method = "PUT";

                const body = HostConfigurationEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.HOST_CONFIGURATIONS],
        }),
    }),
});

export const { useHostConfigurationLoadQuery, useHostConfigurationSaveMutation, useHostConfigurationUpdateMutation } = HostConfigurationApi;
